import React, { useState } from 'react';
import CountrySelector from '../components/CountrySelector';
import PhoneInput from 'react-phone-number-input';
import LawyerServicesHeader from '../assets/lawyer_services-header.png';
import LawyerServicesImage from '../assets/lawyer_services-main.png'
import '../styles/LawyerServicesHeader.css'
import '../styles/LawyerServicesMain.css'
import emailjs from '@emailjs/browser';


const LawyerServicesPage = () => {
    const [selectedOption, setSelectedOption] = useState('');
    const [lawyerServicesName, setLawyerServicesName] = useState('');
    const [lawyerServicesEmail, setLawyerServicesEmail] = useState('');
    const [lawyerServicesCountry, setLawyerServicesCountry] = useState('');
    const [lawyerServicesCity, setLawyerServicesCity] = useState('');
    const [lawyerServicesZipCode, setLawyerServicesZipCode] = useState('');
    const [lawyerServicesPhoneNumber, setLawyerServicesPhoneNumber] = useState('');
    const [lawyerServicesCaseDescription, setLawyerServicesCaseDescription] = useState('');

    const handleCountryChange = (selectedCountry) => {
        setLawyerServicesCountry(selectedCountry);
    };

    const handleDropdownChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formDetails = {
            name: lawyerServicesName,
            email: lawyerServicesEmail,
            country: lawyerServicesCountry,
            city: lawyerServicesCity,
            zipCode: lawyerServicesZipCode,
            number: lawyerServicesPhoneNumber,
            lawyerService: selectedOption,
            description: lawyerServicesCaseDescription
        };
        emailjs.send('service_bweo396', 'template_g2n6cc9', formDetails, '3YyDVJ1mlye_xPa7F')
        setLawyerServicesName('')
        setLawyerServicesEmail('')
        setLawyerServicesCity('')
        setLawyerServicesCountry('')
        setLawyerServicesZipCode('')
        setLawyerServicesPhoneNumber('')
        setLawyerServicesCaseDescription('')
    };


    return (
        <>
            <header>
                <div className="lawyer_services-header-wrapper">
                    <img src={LawyerServicesHeader} alt="" className="lawyer_services-header-image" />
                    <div className="lawyer_services-header-gradient" />
                    <div className="row">
                        <div className="lawyer_services-header-content">
                            <h1 className="lawyer_services-header-title">Services For Lawyers</h1>
                            <p className="lawyer_services-header-para">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <div className="row">
                    <div className="lawyer_services-main-wrapper">
                        <div className='lawyer_services-form-wrapper'>
                            <h1 className='lawyer_services-form-title'>Business Enquiry</h1>
                            <p className='lawyer_services-form-para'>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin,
                                lorem quis bibendum nisi elit consequat ipsum, nec sagittis sebh id sed sit.
                            </p>
                            <form onSubmit={handleSubmit} className='lawyer_services-form'>
                                <select value={selectedOption} onChange={handleDropdownChange} required className='lawyer_services-form-dropdown'>
                                    <option className='lawyer_services-form-dropdown-disbaled' disabled value="">Select lawyer services</option>
                                    <option className='lawyer_services-form-dropdown-option' value="Data Entry Services">Data Entry Services</option>
                                    <option className='lawyer_services-form-dropdown-option' value="Worldwide Client Acquisition & Business Development">Worldwide Client Acquisition & Business Development</option>
                                    <option className='lawyer_services-form-dropdown-option' value="Asylum Statement & Legal Documents Translation">Asylum Statement & Legal Documents Translation</option>
                                    <option className='lawyer_services-form-dropdown-option' value="Legal Forms/Document Filing Assistance">Legal Forms/Document Filing Assistance</option>
                                </select>
                                <input required type="text" className='lawyer_services-form-name' placeholder="Name" value={lawyerServicesName} onChange={(e) => setLawyerServicesName(e.target.value)} />
                                <input required type="email" className='lawyer_services-form-email' placeholder="Email" value={lawyerServicesEmail} onChange={(e) => setLawyerServicesEmail(e.target.value)} />
                                <div className='form_country-city-wrapper'>
                                    <CountrySelector className='lawyer_services-form-country' value={lawyerServicesCountry} onChange={handleCountryChange} />
                                    <input required type="text" placeholder="City" className='lawyer_services-form-city' value={lawyerServicesCity} onChange={(e) => setLawyerServicesCity(e.target.value)} />
                                </div>
                                <input required type="text" className='lawyer_services-form-zip' placeholder="Zip Code" value={lawyerServicesZipCode} onChange={(e) => setLawyerServicesZipCode(e.target.value)} />
                                <PhoneInput
                                    placeholder="Phone Number"
                                    defaultCountry='IN'
                                    className='lawyer_services-form-phone'
                                    value={lawyerServicesPhoneNumber}
                                    onChange={setLawyerServicesPhoneNumber}
                                    required
                                />
                                <textarea required placeholder="Case Description..." className='lawyer_services-form-description' value={lawyerServicesCaseDescription} onChange={(e) => setLawyerServicesCaseDescription(e.target.value)} />
                                <button type="submit" className='lawyer_services-form-submit'>Send Request</button>
                            </form>
                        </div>
                        <img src={LawyerServicesImage} alt="" className="lawyer_services-image" />
                    </div>
                </div>
            </main>
        </>
    );
}

export default LawyerServicesPage;
